export default {
  en: {
    remark: 'Remark',
    editRemark: 'Edit Remark'
  },
  th: {
    remark: 'หมายเหตุ',
    editRemark: 'แก้ไข หมายเหตุ'
  }
}
